import { isEmptyText, Prismic, PrismicText } from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import React from 'react';
import {
  NumberItem,
  TextWithNumbers,
} from '../components/slices/TextWithNumbers';

interface IProps {
  copy: Prismic.RichText;
  label: Prismic.RichText;
  description: Prismic.RichText;
  color: 'Default' | 'Auto' | 'Blue' | 'LightBlue' | 'Cyan' | 'Orange';
  fields: IField[];
}

interface IField {
  number: Prismic.RichText;
  text: Prismic.RichText;
  color: string;
  link: Prismic.Link;
}

export const TextWithNumbersContainer = ({
  copy,
  label,
  description,
  color,
  fields,
}: IProps) => {
  if (isEmptyText(copy)) {
    return null;
  }
  const isArticle = true;

  return (
    <Segment isArticle={isArticle}>
      <TextWithNumbers
        copy={<PrismicText value={copy} isArticle={isArticle} />}
        label={
          isEmptyText(label) ? undefined : Prismic.text(label) ?? undefined
        }
        color={color}
        description={
          isEmptyText(description) ? null : <PrismicText value={description} />
        }
      >
        {fields?.length &&
          fields.map((item, i) => {
            return (
              <NumberItem
                key={`number-${i}`}
                number={Prismic.text(item?.number)}
                text={Prismic.text(item?.text)}
                color={color}
                link={item.link}
              />
            );
          })}
      </TextWithNumbers>
    </Segment>
  );
};
